import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const state = {
  profile: {
    pictures: []
  },
  profiles: [],
  seenProfilesLinkedList: {
      value: {},
      next: null,
      prev: null,
      index: 0
  },
  seenProfilesLength: 0,
  seenProfilesTail: null,
  currentSeenUser: null,
  meta: [],
  smile: "",
  blocked: [],
  complaints: [],
  photos: [],
  moreprofiles: [],
  settings: null,
  currentPaginationPage: 0,
  searchParams: {}
};

export default {
  state,
  mutations,
  actions,
  getters
};
